module.exports = __webpack_public_path__ + "static/media/info.560df7a8.svg";